import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-contact",
  "use": "rt-base-contact-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-contact\">\r\n<path d=\"M163,729.8h43.6c26.2,0,43.6-17.4,43.6-43.6s-17.4-43.6-43.6-43.6H163v-87.1h43.6c26.2,0,43.6-17.4,43.6-43.6\r\n\ts-17.4-43.6-43.6-43.6H163v-87.1h43.6c26.2,0,43.6-17.4,43.6-43.6s-17.4-43.6-43.6-43.6H163V163.6c0-26.1,17.4-43.6,43.6-43.6h610.8\r\n\tc26.2,0,43.6,17.4,43.6,43.6v696.9c0,26.1-17.5,43.6-43.6,43.6H206.6c-26.2,0-43.6-17.4-43.6-43.6V729.8L163,729.8z M656,616.5\r\n\tc-13.1,13.1-34.9,13.1-52.3,0l-135.2-135c-13.1-13.1-13.1-34.8,0-47.9l26.2-26.1c13.1-13.1,13.1-34.8,0-52.3l-52.4-52.3\r\n\tc-13.1-13.1-34.9-13.1-52.3,0L368,329.1c-56.7,56.6-26.2,117.6,30.5,174.2l183.2,182.9c56.7,56.6,117.8,87.1,174.5,30.5l26.2-26.1\r\n\tc13.1-13.1,13.1-34.8,0-52.3l-52.3-47.9c-13.1-13.1-34.9-13.1-52.3,0L656,616.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/contact.svg
// module id = 1681
// module chunks = 228